import React from "react"

import PermissionHolderListItem from "../PermissionHolderListItem"
import SpinnerImage from "../SpinnerImage"
import WidgetHeaderButton from "../WidgetHeaderButton"

const PermissionHoldersEditWidget = ({
    permissionHolders,
    selectedType,
    searchTerm,
    onTypeChange,
    onRemove,
    onSearch,
    onChecked,
    onApplyAdd,
    onCancel,
    isFetching,
    isAdding,
    searchResults
}) => (
    <div className="widget">
        <h3 className="widget-header">
            <span className="icon icon-insights" />
            Permissions
            {isFetching && <SpinnerImage />}
            {isAdding && (
                <div className="pull-right">
                    <WidgetHeaderButton isSecondary={true} onClick={onCancel}>
                        Cancel
                    </WidgetHeaderButton>
                    <WidgetHeaderButton onClick={onApplyAdd}>
                        Add
                    </WidgetHeaderButton>
                </div>
            )}
        </h3>
        <div className="quick-filters">
            <select
                className="form-control"
                value={selectedType}
                onChange={onTypeChange}
            >
                <option value="viewers">Viewers</option>
                <option value="owners">Owners</option>
            </select>
            <div className="search-bar-container">
                <span className="searchicon">
                    <input
                        type="search"
                        placeholder={`search to add ${selectedType}`}
                        name="permission-holder-search"
                        className="form-control"
                        onChange={onSearch}
                    />
                </span>
            </div>
        </div>
        <div className="widget-content list-group items-list auto">
            {isFetching && <SpinnerImage isCentral={true} />}
            {!isAdding
                ? permissionHolders.map(props => (
                      <PermissionHolderListItem
                          key={props.id}
                          {...props}
                          onRemove={onRemove(selectedType, props.id)}
                      />
                  ))
                : searchResults.map(props => (
                      <PermissionHolderListItem
                          key={props.id}
                          {...props}
                          onChecked={onChecked}
                      />
                  ))}
            {!isAdding &&
                permissionHolders.length <= 0 && (
                    <p style={{ marginTop: "10px" }}>No {selectedType}</p>
                )}
            {isAdding &&
                !isFetching &&
                searchResults.length <= 0 && (
                    <p style={{ marginTop: "10px" }}>
                        `Your search didn't match any results.`
                    </p>
                )}
        </div>
    </div>
)

export default PermissionHoldersEditWidget
